import React, {useState, useEffect, useRef, useReducer} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {verifyUser, logoutUser} from "../authRequests";
import {loadDataForPatientLogin} from "../crudRequests";
import Navbar from "../components/Patient.Navbar";
import Notifications from "../components/Patient.Notifications";
import Profile from "../components/Information";
import InsuranceInfoForm from "../components/InsuranceInfoForm";
import {patientReducer, init} from "../additional_files/reducer";
import {SocketContext} from "../additional_files/context";
import {useSocket} from "../additional_files/custom";
import Layout from "../components/Layout";
import {VStack, Box} from "@chakra-ui/react";
export default function User(props) {
  const navigate = useNavigate();
  const [tab, setTab] = useState("prs");
  const loadedRef = useRef(null);
  const {state} = useLocation();
  const [dashState, dispatch] = useReducer(patientReducer, state, init);
  const [prevState, setPrevState] = useState(dashState);

  let room = dashState.patient?.pid;

  useEffect(function () {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  if (prevState !== dashState) {
    setPrevState(dashState);
    navigate("../user", {
      state: {
        ...dashState,
      },
    });
  }

  //const socket = useSocket('http://localhost:3000/', room, dispatch);

  return (
    <>
      <Layout state={{...dashState}} dispatch={dispatch}>
        <div
          ref={loadedRef}
          style={{opacity: 0}}
          className="relative flex flex-1 w-full h-full flex-col"
        >
          <Box flex={1} overflow="auto">
            <Profile state={dashState} dispatch={dispatch}/>
          </Box>
        </div>
      </Layout>
    </>
  );
}
